import Link from 'next/link';
import styles from './MenuAnnouncement.module.css';

const WinWithFriendsAnnouncement = () => (
  <div className={styles.winWithFriends}>
    <Link href="/referrals">
      <a href="/referrals">
        <div>
          Invite your friend <br />
          and win together
        </div>
        <div>Discover more</div>
      </a>
    </Link>
  </div>
);

export default WinWithFriendsAnnouncement;
